import React, { useState, useEffect, useMemo } from "react";
import "./weekpicker.css";
import { v4 } from "uuid";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowRight } from "./ArrowRight";
import { addMonths, endOfWeek, startOfWeek, subMonths,addWeeks,subWeeks } from "date-fns";
import getDaysInMonth from "date-fns/getDaysInMonth";
import { translate } from "../../utils/translations/translate";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../utils/constants";

export const WeekPicker = ({ onChange,disableFuture=false }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const currentDateInfo = useMemo(()=>{
    return {
      day:new Date().getDate(),
      month:new Date().getMonth()+1
    }
  },[])
  const [week, setWeek] = useState({
    firstDay: startOfWeek(new Date(), { weekStartsOn: 1 }),
    lastDay: endOfWeek(new Date(), { weekStartsOn: 1 }),
  });
  const currentWeek = useMemo(() => {
    return {
      firstDay: startOfWeek(new Date(), { weekStartsOn: 1 }),
      lastDay: endOfWeek(new Date(), { weekStartsOn: 1 }),
    };
  }, []);
  useEffect(() => {
    onChange && onChange(week);
  }, [week,onChange]);
  const isLeapYear = () => {
    let leapYear = new Date(new Date().getFullYear(), 1, 29);
    return leapYear.getDate() === 29;
  };

  const convertDate = (date) => {
    let dt = new Date(date);
    return moment(dt).format(DATE_TIME_FORMAT.DISPLAY)
  };

  const handleClick = (e) => {
    let localDate;
    if (e.target.id.includes("prev")) {
      localDate = new Date(date.setDate(1));
      setDate(new Date(date.setDate(1)));
    } else if (e.target.id.includes("next")) {
      localDate = new Date(date.setDate(getDaysInMonth(date)));
      setDate(new Date(date.setDate(getDaysInMonth(date))));
    } else {
      localDate = new Date(date.setDate(e.target.id));
      setDate(new Date(date.setDate(e.target.id)));
    }
    const firstDay = startOfWeek(localDate, { weekStartsOn: 1 });
    const lastDay = endOfWeek(localDate, { weekStartsOn: 1 });
    const currentDay = new Date();
    if(firstDay>currentDay && disableFuture){
       return  false;
    }
    setWeek({ firstDay, lastDay });
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const days = {
    1: 31,
    2: isLeapYear() ? 29 : 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
  };

  const renderDays = () => {
    let month = date.getMonth() + 1;
    let ar = [];
    const today = new Date();
    const isFutureDisabled = disableFuture ?? false;
    const currentWeekLastDay = new Date(today);
    currentWeekLastDay.setDate(today.getDate() + (7 - today.getDay()));
  
    for (let i = 1; i <= days[month]; i++) {
      let currentDate = new Date(date).setDate(i);
  
      let cName = "single-number ";
      if (
        new Date(week.firstDay).getTime() <= new Date(currentDate).getTime() &&
        new Date(currentDate).getTime() <= new Date(week.lastDay).getTime()
      ) {
        cName = cName + "selected-week";
      }
      if (isFutureDisabled && new Date(currentDate).getTime() > currentWeekLastDay.getTime()) {
        cName += " disabled";
      }
  
      ar.push(
        <div 
          key={v4()} 
          id={i} 
          className={cName} 
          onClick={isFutureDisabled && new Date(currentDate).getTime() > currentWeekLastDay.getTime() ? null : handleClick}
        >
          {i}
        </div>
      );
    }
  
    const displayDate = new Date(date).setDate(1);
    let dayInTheWeek = new Date(displayDate).getDay();
    if (dayInTheWeek < 1) {
      dayInTheWeek = 7;
    }
    let prevMonth = [];
    let prevMonthDays = new Date(date).getMonth();
    if (prevMonthDays === 0) {
      prevMonthDays = 12;
    }
    for (let i = dayInTheWeek; i > 1; i--) {
      let previousMonth = new Date(date).setMonth(new Date(date).getMonth() - 1);
      let currentDate = new Date(previousMonth).setDate(days[prevMonthDays] - i + 2);
      let cName = "single-number other-month";
      let currentTime = new Date(currentDate).getTime();
      let firstTime = new Date(week.firstDay).getTime();
      let endTime = new Date(week.lastDay).getTime();
      
      if (currentTime >= firstTime && currentTime <= endTime) {
        cName = "single-number selected-week";
      }
  
      prevMonth.push(
        <div
          onClick={handleClick}
          key={v4()}
          id={"prev-" + i}
          className={cName}
        >
          {days[prevMonthDays] - i + 2}
        </div>
      );
    }
  
    let nextMonth = [];
    let fullDays = 35;
    if ([...prevMonth, ...ar].length > 35) {
      fullDays = 42;
    }
  
    for (let i = 1; i <= fullDays - [...prevMonth, ...ar].length; i++) {
      let cName = "single-number other-month";
      const lastDay = week.lastDay.getTime();
      const lastDayOfMonth = new Date(new Date(date).setDate(getDaysInMonth(date)));
  
      if (
        lastDayOfMonth.getTime() <= lastDay &&
        week.firstDay.getMonth() === lastDayOfMonth.getMonth()
      ) {
        cName = "single-number selected-week";
      }
  
      if (isFutureDisabled && lastDayOfMonth.getTime() > currentWeekLastDay.getTime()) {
        cName += " disabled";
      }
  
      nextMonth.push(
        <div
          onClick={isFutureDisabled && lastDayOfMonth.getTime() > currentWeekLastDay.getTime() ? null : handleClick}
          key={v4()}
          id={"next-" + i}
          className={cName}
        >
          {i}
        </div>
      );
    }
    return [...prevMonth, ...ar, ...nextMonth];
  };
  
  

  const handleDate = (next) => {
    let localDate = new Date(date);
    if (next) {
      localDate = addMonths(localDate, 1);
    } else {
      localDate = subMonths(localDate, 1);
    }
    setDate(new Date(localDate));
  };
  const handleWeekChange = (next) => {
    let localDate = new Date(week.firstDay); 
    if (next) {
      localDate = addWeeks(localDate, 1);
    } else {
      localDate = subWeeks(localDate, 1);
    }
    const firstDay = startOfWeek(localDate, { weekStartsOn: 1 });
    const lastDay = endOfWeek(localDate, { weekStartsOn: 1 });
    setWeek({ firstDay, lastDay });
  };
  const isCurrentWeekSelected =
    convertDate(currentWeek.firstDay) === convertDate(week.firstDay) &&
    convertDate(currentWeek.lastDay) === convertDate(week.lastDay);
  const isOnPrevMonth = currentDateInfo.month <= date.getMonth()+1;
  const isOnPreviousWeek = convertDate(currentWeek.firstDay) < date;
  const disableFutureMonthNavigation = (disableFuture) && (isOnPrevMonth);
  const disableFutureWeekNavigation = (disableFuture) && (isOnPreviousWeek || isCurrentWeekSelected);
  return (
    <div
      className="week-picker-display"
      onBlur={() => setOpen(false)}
      onClick={() => setOpen(true)}
      tabIndex={0}
    >
      <div className="selected-week-display">
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleWeekChange();
          }}
          className="arrow-container"
        >
          {" "}
          {ArrowLeft}{" "}
        </div>
        <div className="selected-week-indicator">
          <span>{convertDate(week.firstDay)} - {convertDate(week.lastDay)}</span>
          {isCurrentWeekSelected && <span>{translate('labels.currentWeek')}</span>}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            if(disableFutureWeekNavigation) return;
            handleWeekChange(true);
          }}
          className={`arrow-container ${
            disableFutureWeekNavigation ? 'disabled':""}`}
        >
          {ArrowRight}
        </div>
      </div>
      {open && (
        <div className="week-picker-options">
          <div className="title-week">
            <div onClick={() => handleDate()} className="arrow-container">
              {ArrowLeft}
            </div>
            {`${months[date.getMonth()]} ${date.getFullYear()}.`}
            <div onClick={() =>{
               if(disableFutureMonthNavigation) return;
               handleDate(true)
            }} className={`arrow-container ${disableFutureMonthNavigation ? 'disabled':""}`}>
              {ArrowRight}
            </div>
          </div>
          <div className="numbers-container">
            <div className="single-number day">Mon</div>
            <div className="single-number day">Tue</div>
            <div className="single-number day">Wed</div>
            <div className="single-number day">Thu</div>
            <div className="single-number day">Fri</div>
            <div className="single-number day">Sat</div>
            <div className="single-number day">Sun</div>
          </div>
          <div className="numbers-container">{renderDays()}</div>
        </div>
      )}
    </div>
  );
};
